interface Props {
  size?: number;
  class?: string;
}

function Spinner({ size = 20, class: _class }: Props) {
  return (
    <div
      style={{
        verticalAlign: "-0.125em",
        border: "0.125em solid",
        borderRightColor: "transparent",
        width: size,
        height: size,
      }}
      class={`animate-spin inline-block border-2 rounded-full ${_class}`}
      role="status"
    >
      <span class="hidden">Carregando...</span>
    </div>
  );
}

export default Spinner;
